module.exports = __webpack_public_path__ + "img/back_2.96a874da.png";